import React, {useEffect, useRef, useState} from 'react';
import Grid from "@material-ui/core/Grid";


import {withRouter} from 'react-router-dom';
import Box from "@material-ui/core/Box";
import useStyles from "../../styles";
import {useDispatch, useSelector} from "react-redux";
import EnhancedTable from "../../components/EnhancedTable";
import SiteWrapper from "../../SiteWrapper";
import Typography from "@material-ui/core/Typography";
import {httpWrapper} from "../../helper/Http";
import {contentTypeApplicationJson} from "../../constants/httpConstants";
import {utils} from "../../helper/Utils";
import {useFormik} from "formik";
import dayjs from "dayjs"
import * as Yup from "yup";
import {getMachinesAction} from "../../store/actions/MachineAction";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DayjsUtils from "@date-io/dayjs";
import Button from "@material-ui/core/Button";
import clsx from "clsx";
import ExportToPdfComponent from "../../components/ExportToPdfComponent";
import BreadCrumb from "../../components/BreadCrumb";
import TextField from "@material-ui/core/TextField/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";


const TripReportPage = () => {

    const classes = useStyles();

    const dispatch = useDispatch();

    const [trips, setTrips] = useState([]);
    const machines = useSelector(state => state.machine.machines);
    const [count, setCount] = useState(0);

    const fetchIdRef = useRef(0);


    const url = '/reports/trips-history/';


    const fetchData = React.useCallback((query, cb) => {

        const fetchId = ++fetchIdRef.current;

        if (fetchId === fetchIdRef.current) {

            httpWrapper.get(url, contentTypeApplicationJson, query).then(
                (response) => {
                    if (response.data) {
                        setTrips(response.data.results.trips);
                        setCount(response.data.results.trips.length);
                    }

                    cb && cb();
                },
                (error) => {

                    cb && cb();
                }
            );
        }
    }, []);


    useEffect(() => {

        dispatch(getMachinesAction());

        fetchData({
            type: "trip",
            start_date: utils.DEFAULT_START_DATE,
            end_date: utils.DEFAULT_END_DATE
        }, null);

    }, [dispatch, fetchData]);


    const formik = useFormik({

        initialValues: {
            start_date: utils.DEFAULT_START_DATE,
            end_date: utils.DEFAULT_END_DATE,
            machine: '',
        },

        validationSchema: Yup.object().shape({
            start_date: Yup.date("YYYY-mm-dd").required('Start date is required'),
            end_date: Yup.date("YYYY-mm-dd").required('End date is required'),
        }),

        onSubmit(values) {

            fetchData(values, callback);
        },

        enableReinitialize: true

    });

    const callback = () => {
        formik.setSubmitting(false);
    };

    const columns = [

        {
            Header: "Departure Date",
            accessor: d => (dayjs(d.departure).format(utils.dateFormat))
        },
        {
            Header: "Horse",
            accessor: "horse"
        },
        {
            Header: "Trailer",
            accessor: (d => d.trailer ?? '-')
        },
        {
            Header: "Driver",
            accessor: (d => d.driver ?? '-')
        },
        {
            Header: "Co-Driver",
            accessor: (d => d.co_driver ?? '-')
        },
        {
            Header: "Route",
            accessor: (d => d.route ?? '-')
        },
        {
            Header: "Mileage",
            accessor: (d => utils.numberFormatter(d.mileage))
        }
    ];

    return (
        <>
            <SiteWrapper>
                <BreadCrumb crumbs={[{
                    'name': 'Reports',
                    'link': '/reports'
                },
                    {
                        'name': 'Trips Report',
                        'link': '#'
                    }]}/>
                <Grid container className={classes.marginTop}>
                    <Grid item xs={12} sm={4}>
                        <Box>
                            <Typography className={classes.medium}>
                                Trips History
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid container item xs={12} sm={8} justify="flex-end">
                        <Box>
                            {trips && <ExportToPdfComponent url={url}/>}
                        </Box>
                    </Grid>
                </Grid>

                <Grid container className={classes.marginTop}>

                    <form className={classes.form} onSubmit={formik.handleSubmit} noValidate>

                        <Grid container spacing={2}>

                            <Grid item xs={12} sm={3}>
                                <MuiPickersUtilsProvider utils={DayjsUtils}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        id="date-picker-dialog"
                                        label="Start Date"
                                        maxDate={utils.maxDate}
                                        format="MM/DD/YYYY"
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        value={formik.values.start_date}
                                        onChange={val => formik.setFieldValue('start_date', dayjs(val).format("YYYY-MM-DD"))}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>


                            <Grid item xs={12} sm={3}>
                                <MuiPickersUtilsProvider utils={DayjsUtils}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        id="date-picker-dialog"
                                        label="End Date"
                                        format="MM/DD/YYYY"
                                        maxDate={utils.maxDate}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        value={formik.values.end_date}
                                        onChange={val => formik.setFieldValue('end_date', dayjs(val).format("YYYY-MM-DD"))}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>

                            <Grid item xs={12} sm={3}>
                                {/*<FormControl className={clsx(classes.formControl, classes.formsWithMui)}>*/}
                                {/*    <InputLabel>Truck</InputLabel>*/}
                                {/*    <Select*/}
                                {/*        name="machine"*/}
                                {/*        onChange={formik.handleChange}*/}
                                {/*        value={formik.values.machine || ''}*/}
                                {/*        error={formik.touched.machine && Boolean(formik.errors.machine)}*/}
                                {/*        helperText={formik.touched.machine && formik.errors.machine}*/}
                                {/*    >*/}
                                {/*        <MenuItem value="">Select Value</MenuItem>*/}
                                {/*        {machines && machines.map((m, idk) => <MenuItem*/}
                                {/*            value={m.id}*/}
                                {/*            key={idk}>{m.reg_no}</MenuItem>)}*/}
                                {/*    </Select>*/}
                                {/*</FormControl>*/}
                                <Autocomplete
                                    filterOptions={utils.autocompleteFilterOptions}
                                    className={clsx(classes.formControl, classes.formsWithMui)}
                                    disablePortal
                                    options={machines}
                                    getOptionLabel={option => option.reg_no}
                                    name='machine'
                                    defaultValue={formik.values.machine || null}
                                    getOptionSelected={(option, value) => option.reg_no === value.reg_no}
                                    onChange={(_, value) => value != null ? formik.setFieldValue('machine', value.reg_no) : ''}
                                    renderInput={(params) => <TextField {...params}
                                                                        error={formik.errors.machine && Boolean(formik.touched.machine)}
                                                                        helperText={formik.errors.machine && formik.touched.machine}
                                                                        name={'machine'}
                                                                        label="Truck"/>}
                                />
                            </Grid>
                        </Grid>
                    </form>
                    <Grid container justify="center">
                        <Button
                            onClick={formik.handleSubmit}
                            type="button"
                            size="small"
                            variant="contained"
                            color="secondary"
                            className={clsx(classes.primary, classes.formsWithMui)}
                            disabled={formik.isSubmitting}
                        >
                            Filter
                        </Button>
                    </Grid>
                </Grid>

                <Grid container justify="flex-end" className={classes.marginTop}>
                    {/* Recent Deposits */}
                    <Grid item xs={12} md={12} lg={12}>
                        {trips && <EnhancedTable
                            columns={columns}
                            data={trips}
                            pageCount={count}
                            summaries={false}
                        />}
                    </Grid>
                </Grid>
            </SiteWrapper>
        </>
    );
};

export default withRouter(TripReportPage);